/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const SearchOutlinedIcon = createIcon({
    displayName: 'SearchOutlinedIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M10.947 5.35c3.725 0 5.614 1.89 5.614 5.614 0 1.513-.326 2.745-.967 3.661l-.392.477-.398.374c-.925.731-2.223 1.102-3.857 1.102-3.725 0-5.614-1.889-5.614-5.614 0-3.725 1.889-5.613 5.614-5.613Zm0-1.332C6.486 4.018 4 6.503 4 10.964s2.486 6.947 6.947 6.947c1.955 0 3.53-.478 4.684-1.39l3.243 3.462L20 18.927l-3.315-3.537c.79-1.127 1.209-2.61 1.209-4.426 0-4.46-2.486-6.946-6.947-6.946Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "m22.73 21.317-4.295-4.583C19.458 15.274 20 13.353 20 11c0-5.78-3.22-9-9-9-5.78 0-9 3.22-9 9 0 5.78 3.22 9 9 9 2.533 0 4.574-.619 6.068-1.8l4.202 4.484 1.46-1.367ZM11 18c-4.645 0-7-2.355-7-7s2.355-7 7-7 7 2.355 7 7-2.355 7-7 7Z"
        })
    ]
});
SearchOutlinedIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'SearchOutlinedIcon'
};
export { SearchOutlinedIcon };

//# sourceMappingURL=search_outlined.js.map